<template>
  <div v-if="!minimized" class="bg-yellow-300 fixed inset-x-0 top-0 py-2" style="z-index: 200">
    <div class="app-container">
      <div class="flex items-center justify-between">
        <div class="w-0 flex-1 flex items-center">
          <span class="flex p-2 rounded-lg bg-red-600">
            <MaskIcon class="h-6 w-6 text-white" />
          </span>
          <p class="ml-3 text-yellow-700 truncate">
            <span class="sm:hidden">
              {{ hijackedUser.first_name }} {{ hijackedUser.last_name }}
            </span>
            <span class="hidden sm:inline">
              Connecté à la place de <avatar :user="hijackedUser" class="ml-2" size="small" />
              <span class="font-medium"
                >{{ hijackedUser.first_name }} {{ hijackedUser.last_name }}</span
              >
              ({{ roleOrOrganisation }})
            </span>
          </p>
        </div>
        <div class="shrink-0 order-2 w-auto flex items-center space-x-1">
          <t-button leading-icon="SolidEyeOffIcon" @click="minimized = true"> Cacher </t-button>
          <form action="/hijack/release/" method="POST">
            <CsrfToken />
            <input type="hidden" name="next" value="/" />
            <t-button html-type="submit" leading-icon="SolidLogoutIcon" type="danger.secondary">
              Arrêter
            </t-button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="bg-transparent fixed top-0 py-2" style="z-index: 200">
    <div class="pl-3 sm:pl-6">
      <div class="flex items-center justify-center">
        <div class="flex-1 flex items-center">
          <t-button leading-icon="MaskIcon" type="danger" @click="minimized = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CsrfToken from '@/components/CsrfToken.vue'
import Avatar from '@/components/users/Avatar.vue'
import { useLocalStorage } from 'vue-composable'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const rolesMap: Record<string, string> = {
  manager: 'CdP',
  client: 'PdP',
  agency: 'Agence',
  pro: 'Pro',
}

const props = withDefaults(
  defineProps<{
    userJson?: string
  }>(),
  {
    userJson: '',
  },
)

const { storage: minimized } = useLocalStorage('archibien-impersonation-opened', false)
const { props: pageProps } = usePage()

const hijackedUser = computed(() => {
  // When userJson prop is given from Django template convert it to object
  // else use inertia shared prop
  if (props.userJson) {
    const user = JSON.parse(props.userJson.replace(/'/g, '"'))
    return user
  } else {
    return pageProps.user
  }
})

const roleOrOrganisation = computed(() => {
  if (['agency', 'pro'].includes(hijackedUser.value.role)) {
    return hijackedUser.value.organisation
  } else {
    return rolesMap[hijackedUser.value.role]
  }
})
</script>
